jQuery(document).ready(function ($) {

	//SMOOTH SCROOL
	$('.roll a').click(function(event) {
		var target = $(this.getAttribute('href'));
		if( target.length ) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top
			}, 1000);
		}
	});

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

	//REPRESENTANTES
	$('#seletor-estado a').click(function(e) {
		e.preventDefault();

		var classe = $(this).attr('data-estado');
		var titulo = $(this).attr('data-title');

		//SETAR TITULO NA SEÇÃO
		//$('h3.representantes-titulo').html(titulo);

		//SETAR ITEM ATIVO
		$('#seletor-estado a').removeClass('active');
		$(this).addClass('active');

		console.log(classe);

		//MOSTRAR ESCONDER OS PRODUTOS
		if(classe == 'todos') {
			$('.item-representante').slideDown('fast');
		} else {
			$('.item-representante').slideUp('fast');
			$('.'+classe).slideDown('fast');
		}
	});

	//LISTA DE PRODUTOS
	$('.menu-produtos a').click(function(e) {
		e.preventDefault();

		var classe = $(this).attr('data-linha');
		var titulo = $(this).attr('data-title');
		var desc   = $(this).attr('data-desc');

		//ABRIR FECHAR DROPDOWN
		$(this).parent().find('> .dropdown-menu-linhas').slideToggle('fast');

		//SETAR TITULO NA SEÇÃO
		$('h2.produtos-linha-titulo').html(titulo);

		//SETAR DESCRICAO NA SECAO
		if(!desc) {
			$('.desc-linha').addClass('d-none');
		} else {
			$('.desc-linha').removeClass('d-none');
			$('.desc-linha').html(desc.replace(/(?:\r\n|\r|\n)/g, '<br>'));
		}

		//MOSTRAR ESCONDER OS PRODUTOS
		if(classe == 'todos') {
			$('.linha-produto-container').slideDown('fast');
		} else {
			$('.linha-produto-container').slideUp('fast');
			$('.'+classe).slideDown('fast');
		}
	});

	//DISPARAR CLICK EM CULTURA
	if (typeof filtro_var !== 'undefined') {
		$('#filtro-'+filtro_var).trigger('click');
	}

	//COLOCAR PRIMEIRO ITEM DAS ABAS COMO ATIVO
	$('.tabela-produto .nav a.nav-link:first').addClass('active');
	$('.tabela-produto .nav a.nav-link:first').tab('show');
	//$('.zueira').tab('show');
	$('.tabela-produto .tab-content .tab-pane:first').addClass('show active');

	//CARROSSEIS
	$('.slider-carrosel').owlCarousel({
		loop:true,
		margin:0,
		autoplay:true,
		autoplayTimeout:9000,
		autoHeight: true,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		items:1
	});

	$('.culturas-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:5000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:5
			}
		}
	});

	$('.linhas-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:true,
		autoplayTimeout:6000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

});

window.onscroll = function() { fixHeader() };
const header = document.getElementById("topo");
function fixHeader() {
	if (window.pageYOffset > 1) {
		header.classList.add("scrooled");
	} else {
		header.classList.remove("scrooled");
	}
}